import { useState, useEffect } from 'react'
import { legalService } from '@services/api/legal'
import LegalLayout from '@components/marketing/LegalLayout'

function PrivacyPage() {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    legalService.getPublic('privacy')
      .then(res => { if (res.success) setPage(res.data) })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return (
    <LegalLayout
      badge="Vos données"
      title={page?.title || 'Politique de confidentialité'}
      updatedAt={page?.updated_at}
      loading={loading}
      html={page?.content}
      related={{ to: '/terms', label: 'Conditions générales d\'utilisation' }}
    />
  )
}

export default PrivacyPage
